export class Garantie {
  code: string;
  description: string;
  unite: string;
  cotisation: boolean = false;
  nom : string;
  valeur_min : any;
  valeur_max: any;
}
